import React from "react";
import { Box } from "@chakra-ui/react";
export const LogoutIcon = (props) => {
  const svgStyle = {
    stroke: "none",
    fillRule: "nonzero",
    fill: props.fill,
    fillOpacity: 1,
  };
  return (
    <Box className={props.className} {...props}>
      <svg viewBox="0 0 48 48">
        <path style={svgStyle} d="M 23.978516 4 A 1.50015 1.50015 0 0 0 22.939453 4.4394531 L 16.939453 10.439453 A 1.50015 1.50015 0 1 0 19.060547 12.560547 L 22.498047 9.1230469 L 22.480469 29.498047 A 1.50015 1.50015 0 1 0 25.480469 29.501953 L 25.498047 9.1191406 L 28.939453 12.560547 A 1.50015 1.50015 0 1 0 31.060547 10.439453 L 25.060547 4.4394531 A 1.50015 1.50015 0 0 0 23.978516 4 z M 12.527344 7.9863281 A 1.50015 1.50015 0 0 0 11.599609 8.3242188 C 6.9768903 11.984367 4 17.651052 4 24 C 4 35.027708 12.972292 44 24 44 C 35.027708 44 44 35.027708 44 24 C 44 17.651052 41.02311 11.984367 36.400391 8.3242188 A 1.50015 1.50015 0 1 0 34.537109 10.675781 C 38.47239 13.791633 41 18.586948 41 24 C 41 33.406292 33.406292 41 24 41 C 14.593708 41 7 33.406292 7 24 C 7 18.586948 9.5276097 13.791633 13.462891 10.675781 A 1.50015 1.50015 0 0 0 12.527344 7.9863281 z"/>
      </svg>
    </Box>
  );
};
